export function replaceParameters(route: string, ...params: string[]): string {
  return route
    .split('/')
    .map(path =>
      path.includes(':') ? path.replace(path, params.shift() ?? '') : path,
    )
    .join('/');
}
